import { Component, OnInit } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import { AddLeadDialogComponent } from '../add-lead-dialog/add-lead-dialog.component';
import { AddNewEventDialogComponent } from '../add-new-event-dialog/add-new-event-dialog.component';
import { AddFileDialogComponent } from '../add-file-dialog/add-file-dialog.component';
import { AddProjectDialogComponent } from '../add-project-dialog/add-project-dialog.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {

  }

  openAddLeadDialog(modalType){
    this.dialog.open(AddLeadDialogComponent, {
      width: 'auto',
      data:{modalType:modalType}
    });
  }

  openAddEventDialog(){
    this.dialog.open(AddNewEventDialogComponent, {
      width: 'auto',
    });
  }
  
  openAddFileDialog(){
    this.dialog.open(AddFileDialogComponent, {
      width: 'auto',

    });
  }

  openAddProjectDialog(){
    this.dialog.open(AddProjectDialogComponent, {
      width: 'auto',
    }); 
  }

  showPreview(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.dialog.open(AddFileDialogComponent, {
      width: 'auto',
      data:{
        img: event.target.files[0]
      }
    }); 
    
  }

}
